export function mapApiContactToContact(api) {
    return {
        id: api.id,
        externalId: api.externalId,
        salutation: api.salutation,
        firstName: api.firstName,
        lastName: api.lastName,
        birthDate: api.birthDate ? new Date(api.birthDate) : undefined,
        courtesy: api.courtesy,
        maidenName: api.maidenName,
        gender: api.gender,
        countryOfResidence: api.countryOfResidence,
        preferredLanguage: api.preferredLanguage,
        primaryEmail: api.primaryEmail ?? null,
        primaryPhone: api.primaryPhone ?? null,
        category: api.category ?? null,
        motivation: api.motivation ?? null,
        relationLevel: api.relationLevel ?? null,
        source: api.source ?? null,
        preferredChannel: api.preferredChannel ?? null,
        contactFrequency: api.contactFrequency ?? null,
        status: api.status,
        createdAt: api.createdAt,
        updatedAt: api.updatedAt,
        addresses: (api.addresses ?? []).map((a) => ({
            type: a.type,
            label: a.label,
            line1: a.addressLine,
            line2: a.addressLine2,
            line3: a.addressLine3,
            streetName: a.streetName,
            houseNumber: a.houseNumber,
            houseNumberSuffix: a.houseNumberSuffix,
            postalCode: a.postalCode,
            city: a.city,
            region: a.region,
            country: a.country,
            isPrimary: a.isPrimary,
        })),
        communicationChannels: [],
        organisationRoles: [],
        categories: [],
        tags: [],
    };
}
